import { render, staticRenderFns } from "./assetsadd.html?vue&type=template&id=5ec49c1f&scoped=true&external"
import script from "./assetsadd.vue?vue&type=script&lang=js"
export * from "./assetsadd.vue?vue&type=script&lang=js"
import style0 from "./assetsadd.vue?vue&type=style&index=0&id=5ec49c1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec49c1f",
  null
  
)

export default component.exports